import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Icon,
  Spin
} from 'antd'
import { AppState } from "../../../../stateManager/store"
import { selectedDeviceType, clearFormV2Json, initializeV2Json, selectedDevice, setAssetEditMode, setAssets, discardAssetChanges, setFixedElements, addStyleUrl, isCoreV3Form, setSelectedFormItemId, setModalVisibility, setFixedElementsV3, pushFormActionStack, setFixedElementsUpdateV3, removeElement, pasteCopiedElemenet, undoDeleteElement, applyStyles } from '../../../../stateManager/store/formCreation_v2/actions'

import { attachCoreTypeDefs, decodeBase64 } from "../../../../helpers/commonFunction";
import { initializeA8FormsTypeDefs } from "../../../../helpers/typedefinitions/a8forms";
import { loadPlugins } from "../../../../helpers/MicroFrontend";
import { MARKETPLACE_CORE_V2, MARKETPLACE_CORE_V3 } from "../../../../constant/common";
import { FormProps } from "./PropertiesPanel";
import { SoloFormPropertiesModal } from "../../../navigation/soloFormProperties";
import { FormDesigner } from "./formDesigner";
import { useDispatch, useSelector } from "react-redux";
import { Http } from '../../../../helpers/axois';
import { encodeBase64, useToast, compareDeep } from '../../../../helpers/commonFunction'
import { APIFormData, IAssets, INITIALIZE_ACTION_STACK, Device, FormCreationData, CREATE_FORM_JSON } from '../../../../stateManager/store/formCreation_v2/types'
import { Modal } from '../../../../helpers/commonUi'
import style from './formbuilder.module.sass'
import { Popover } from '@headlessui/react'
import { Popover as AntPopover } from 'antd'

// icons
import { ReactComponent as Desktop } from "../../../../assets/svg/solobuilder/monitor.svg";
import { ReactComponent as Tablet } from "../../../../assets/svg/solobuilder/tablet.svg";
import { ReactComponent as Mobile } from "../../../../assets/svg/solobuilder/mobile.svg";
import Left from "../../../../assets/svg/solobuilder/Left";
import { ReactComponent as ImportIcon } from "../../../../assets/svg/solobuilder/import.svg";
import { UndoSvg } from '../../../../assets/svg/solobuilder/undo';
import { RedoSvg } from '../../../../assets/svg/solobuilder/redo';
import { NavCollapse } from '../../../../assets/svg/solobuilder/navCollapse';
import { ReactComponent as CaretDownIcon } from "../../../../assets/svg/caretDown.svg";
import { ReactComponent as MoreIcon } from "../../../../assets/images/form_icons/moreIconColorless.svg"
import settingIcons from "../../../../assets/images/form_icons/MoreOptionsIcons/settingIcons.svg"
import { useLocation, useHistory, Prompt } from 'react-router-dom';
import { addAssetInstancesToForm, deleteChildAssets, getChildren, getComponents } from "./helpers";
import { logger } from "../../../../constant/winston";
import { LargeDevices, MobileDevices, TabletDevices } from './deviceResolutions'
import { ReactZoomPanPinchRef } from 'react-zoom-pan-pinch'
import { FormPropertiesModal } from "../../../navigation/FormProperties";
import { getRandomId } from "../../../../utils/random-id";
import { containers } from "./constants";
import { myRedoStack, myUndoStack } from "./stack/Stack";
import { getNestedComponents } from "./helpers/getNestedComponents";
import { OS, getOs } from "./helpers/getOs";
import FormPropsLeftNav from "./PropertiesPanel/FormPropsLeftNav";
import useSyncStyles from './helpers/useSyncStyles';
import SyncStyle from './helpers/SyncStyle';
import DuplicateFormModal from "../../Assisted/forms/create/headerOptions/DuplicateFormModal";
import { makeFormDupliacte } from "../../../../helpers/RxServices";
import duplicate from "../../../../assets/images/form_icons/MoreOptionsIcons/duplicateIcon.svg"
import TemplateModal from './template/TemplateModal'
import { TemplateIcon } from '../../../../assets/svg/templates/templateIcons'
import { setSelectedItemId } from "../../../../stateManager/store/contextMenu/action";
import { setStepIndex } from "../../../../stateManager/store/onboarding/action";
import ModalFooter from "../../../../helpers/commonUi/ModalFooter";
import { updateOnboarding } from "../../../../helpers/onboardingHelper";
import { store } from '../../../../stateManager';

export type ZoomLevel = 'in' | 'out' | 'fit' | '50' | '100' | '200'

declare global {
  interface WindowEventMap {
    keydown: React.KeyboardEvent<HTMLInputElement>
  }
}
var makeFormDuplicateVar: any;

const sourceKeys = [
  "components",
  "componentOrder",
  "newId",
  "deviceType",
  "gridStyles",
  "canvasConfig",
  "assets",
  "device",
  "fixedArray",
  "fixedArrayV3",
  "formProperties",
  "isCoreV3",
  "computedStyles",
  "wrapperComputedStyles",
  "styleUrl",
  "version"
]

const sourceKeysCheckedout = [
  "components",
  "componentOrder",
  "newId",
  "gridStyles",
  "assets",
  "fixedArray",
  "fixedArrayV3",
  "formProperties",
  "isCoreV3",
  "styleUrl",
  "version"
]

export const FormCreatev2 = () => {
  const dispatch = useDispatch()
  const { SuccessToast, ErrorToast, WarningToast } = useToast()
  const [loading, setLoading] = useState<boolean>(true);
  const [commitModalVisible, setCommitModalVisible] = useState<boolean>(false);
  const [viewFormProperties, setViewFormProperties] = useState<boolean>(false);
  const [moreOptionsVisible, setMoreOptionsVisible] = useState<boolean>(false);
  const [checkoutModalVisible, setCheckoutModalVisible] = useState<boolean>(false);
  const [resourceLock, setResourceLock] = useState<any>({})
  const [formName, setFormName] = useState<string>("")
  const [showDeviceList, setShowDeviceList] = useState(false)
  const [showZoomPopup, setShowZoomPopup] = useState(false)
  const [isV2, setFormVersion] = useState()
  const [zoomScale, setZoomScale] = useState('Auto')
  const [formData, setFormData] = useState<any>({});
  const fixedArr: any = []
  const zoomRef = useRef<null | ReactZoomPanPinchRef>(null)
  const orgId = useSelector((state: any) => state.org.selectedOrg.id)
  const assetEditMode = useSelector((state: AppState) => state.formJson.assetEditMode)
  const currentState: any = useSelector(state => {
    return state
  })
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const { isCoreV3, fixedArrayV3 } = useSelector((state: any) => state.formJson);
  const { guideVisible, info: onboardingInfo } = useSelector((state: AppState) => state.onboarding)
  const userName = useSelector((state: AppState) => state.user.data.user.userName)
  const { components, componentOrder } = getComponents();
  const viewRef = useRef<any>(null)
  const history = useHistory()
  const pathname = useLocation().pathname
  const locationSplit = pathname.split('/');
  const [rightPropsNavCollapse, setRightPropsNavCollapse] = useState<Boolean>(true);
  const [leftPropsNavCollapse, setLeftPropsNavCollapse] = useState<Boolean>(true);
  const [formSaveModalVisibility, setFormSaveModalVisibility] = useState(false)
  const [duplicateState, setduplicateState] = useState({ visible: false });
  const [tempModalVisible, setTempModalVisible] = useState<boolean>(false);
  const appType = locationSplit[4]
  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(false);
  const { currentBranch, deviceType, selectedElementId, appVersion, json, loggedInUserId, appPermissions, orgPermissions, device } = useSelector((state: AppState) => {
    return {
      currentBranch: state.apps.appBranch,
      deviceType: state.formJson.deviceType,
      device: state.formJson.device,
      selectedElementId: state.formJson.selectedElementId,
      appVersion: state.apps.appVersion,
      json: state.formJson,
      loggedInUserId: state.user.data.user.id,
      appPermissions: state.apps.selectedApp.permissions,
      orgPermissions: state.org.orgPermissions,
    }
  }, compareDeep)
  const component = components[selectedElementId] || {};

  const [savedDevices, setSavedDevices] = useState({
    Sm: MobileDevices[0],
    Md: TabletDevices[0],
    Lg: LargeDevices[0],
    [deviceType]: device
  })

  const { syncStyles } = useSyncStyles();
  const isCheckedIn: boolean = resourceLock.userId === loggedInUserId
  const canEdit = (orgPermissions && orgPermissions.includes('forms.Edit')) || (appPermissions && appPermissions.includes('forms.Edit'))
  const canForceRelease = (orgPermissions && orgPermissions.includes('forms.ForceReleaseLock')) || (appPermissions && appPermissions.includes('forms.ForceReleaseLock'))
  const formId = locationSplit[7]
  const appId = locationSplit[3];
  const branchId = currentBranch && currentBranch[appId] && currentBranch[appId].branchId
  const { versionId, currentVersion } = appVersion[appId]
  const appList = useSelector((state: AppState) => state?.apps?.appsList)
  const selectedApp = appList.find((el: any) => el.appId === appId);
  const randomString = getRandomId();
  const formPropsLeftRef = useRef<any>(null);
  const formPropsRightRef = useRef<any>(null);
  const state = store.getState()
  const {formCoreVersion } = state?.apps || {};

  // used to check if the form is opened from solo journey builder
  const fromSoloRef = useRef(localStorage.getItem(`fromSolo:${formId}`))
  const fromAssistedRef = useRef(localStorage.getItem(`fromAssisted:${formId}`))
  const fromSolo = fromSoloRef.current === "true"
  const fromAssisted = fromAssistedRef.current === "true"
  let [formPropertiesData, setFormPropertiesData] = useState<any>({})
  const formProperties = useSelector((state: any) => state.formJson.formProperties)
  useEffect(() => {
    makeFormDuplicateVar = makeFormDupliacte.getMessage().subscribe((res: any) => {
      if (res?.from === "duplicate") {
        const formData = JSON.parse(JSON.stringify(json));
        addAssetInstancesToForm(formData);
        formData.version = 'v2';
        // the following fields should not be included in the form source
        // as they are only needed in form designer to maintain state
        delete formData.isGridSelected;
        delete formData.isAssetInstanceSelected;
        delete formData.selectedElementId;
        delete formData.modal;
        delete formData.snackbar;
        delete formData.assetEditMode;
        delete formData.actionStack;
        delete formData.actionPointer;
        delete formData.selectedElementsId;
        const data = {
          source: encodeBase64(JSON.stringify(formData)),
          appId: appId,
          version: versionId,
          branchId: branchId,
          styleUrl: json?.styleUrl?.customCssUrl ? json?.styleUrl?.customCssUrl : "",
        }
        Http.put(`/forms/${formId}`, data).subscribe((_formRes) => {
          Http.get(`/duplicateForm/${formId}?appId=${appId}&versionId=${versionId}&formName=${res.formName}&themeId=${res.theme}&branchId=${res.branchId}&displayName=${res.displayName}`).subscribe((formRes) => {
            SuccessToast("Form saved and duplicated successfully");

          }, (err: any) => {
            logger.error("form duplicate error", err);
            ErrorToast((err && err.message) ? err.message : 'Form duplication failed');
          })
        }, (err) => {
          ErrorToast((err && err.message) ? err.message : "Form update failed");
        })
      }

    })
    return () => {
      if (makeFormDuplicateVar) makeFormDuplicateVar.unsubscribe();
    }
  }, [json])

  const getComputedZoomPercent = React.useCallback(() => {
    if (zoomRef && zoomRef.current) {
      return zoomRef.current.state.scale
    }
  }, [])

  // disable pinch zoom in formsBuilder
  useEffect(() => {
    const eventHandler = function (e: any) {
      if ((e.type === 'wheel' && e.ctrlKey) ||
        (e.type === 'keydown' && (e.ctrlKey && e.key === '+' || e.ctrlKey && e.key === '-' || e.ctrlKey && e.code === 'Equal' || e.ctrlKey && e.code === 'Minus'))) {
        e.preventDefault();
      }
    };

    document.addEventListener("wheel", eventHandler, { passive: false });
    document.addEventListener("keydown", eventHandler);

    return () => {
      document.removeEventListener("wheel", eventHandler);
      document.removeEventListener("keydown", eventHandler);
    };
  }, [history]);
  const handleBeforeUnload = (event: any) => {
    event.preventDefault();
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const getZoomScale = (ref: ReactZoomPanPinchRef) => {
    return `${Math.floor(ref.state.scale * 100)}%`
  }

  const onZoomStop = useCallback((ref: ReactZoomPanPinchRef) => {
    setZoomScale(getZoomScale(ref))
  }, [])

  const setNavCollapse = () => {
    setTimeout(() => {
      setTransform(zoomRef, 'fit', 0);
    }, 300)
  }

  useEffect(() => {
    if (!isCheckedIn) {
      setLeftPropsNavCollapse(false);
      setRightPropsNavCollapse(false);
    } else {
      setLeftPropsNavCollapse(true);
      setRightPropsNavCollapse(true);
    }
  }, [isCheckedIn])

  const setTransform = useCallback((ref: React.MutableRefObject<ReactZoomPanPinchRef | null>, zoomLevel?: ZoomLevel, ms: number = 200) => {
    if (['50', '100', '200'].includes(zoomLevel as string)) {
      const scaledValue = parseInt(zoomLevel as string) / 100
      ref?.current?.centerView(scaledValue, 0)
      ref?.current?.setTransform(0, 0, Number(getZoomScale(ref.current)), 0)
      viewRef?.current?.scrollIntoView({ behavior: 'auto', block: "center", inline: "center" });
      return
    }
    if (zoomLevel === 'in') {
      ref?.current?.zoomIn(0.2, 0)
      if (ref?.current?.state?.scale) {
        setZoomScale(getZoomScale(ref.current))
        ref?.current?.setTransform(0, 0, Number(getZoomScale(ref.current)), 0)
        viewRef?.current?.scrollIntoView({ behavior: 'auto', block: "center", inline: "center" });
      }
      return
    }
    if (zoomLevel === 'out') {
      ref?.current?.zoomOut(0.2, 0)
      if (ref?.current?.state?.scale) {
        setZoomScale(getZoomScale(ref.current))
        ref?.current?.setTransform(0, 0, Number(getZoomScale(ref.current)), 0)
        viewRef?.current?.scrollIntoView({ behavior: 'auto', block: "center", inline: "center" });
      }
      return
    }
    if (zoomLevel === 'fit') {
      const hostHeight = ref?.current?.instance?.wrapperComponent?.clientHeight && ref?.current?.instance?.wrapperComponent?.clientHeight / 6
      let hostWidth: number = ref?.current?.instance?.wrapperComponent?.clientWidth && ref?.current?.instance?.wrapperComponent?.clientWidth / 6 || 0
      const canvasHeight = ref?.current?.instance?.contentComponent?.clientHeight
      const canvasWidth = ref?.current?.instance?.contentComponent?.clientWidth
      const shouldScaleDown = hostHeight && hostWidth && canvasHeight && canvasWidth && ((hostHeight <= canvasHeight) || (hostWidth <= canvasWidth))
      const rightNavClientWidth = formPropsRightRef.current ? formPropsRightRef.current.clientWidth : 0;
      const leftNavClientWidth = formPropsLeftRef.current ? formPropsLeftRef.current.clientWidth : 0;

      if (rightNavClientWidth && leftNavClientWidth) {
        hostWidth = hostWidth - (leftNavClientWidth + rightNavClientWidth);
      } else if (rightNavClientWidth) {
        hostWidth = hostWidth - rightNavClientWidth;
      } else if (leftNavClientWidth) {
        hostWidth = hostWidth - leftNavClientWidth;
      }

      if (shouldScaleDown) {
        const heightScale = (hostHeight && canvasHeight) ? hostHeight / canvasHeight : 1
        const widthScale = (hostWidth && canvasWidth) ? hostWidth / canvasWidth : 1
        const leastScale = heightScale >= widthScale ? widthScale : heightScale

        // Giving a 5% runway for extra space
        const finalScale = leastScale * 0.95

        if (hostWidth && hostHeight && canvasWidth && canvasHeight) {
          const scaledCanvasWidth = finalScale * canvasWidth
          const scaledCanvasHeight = finalScale * canvasHeight
          const xOrigin = (hostWidth && scaledCanvasWidth) ? (hostWidth / 2) - (scaledCanvasWidth / 2) : 0
          const yOrigin = (hostHeight && scaledCanvasHeight) ? (hostHeight / 2) - (scaledCanvasHeight / 2) : 0

          ref?.current?.setTransform(xOrigin, yOrigin, finalScale, 0)
          setTimeout(() => {
            if (leftNavClientWidth && rightNavClientWidth) {
              ref?.current?.setTransform(xOrigin, yOrigin, finalScale, 0)
            } else if (rightNavClientWidth) {
              ref?.current?.setTransform(xOrigin - rightNavClientWidth / 2, yOrigin, finalScale, 0)
            } else if (leftNavClientWidth) {
              ref?.current?.setTransform(xOrigin + leftNavClientWidth / 2, yOrigin, finalScale, 0)
            } else {
              ref?.current?.setTransform(xOrigin, yOrigin, finalScale, 0)
            }
          }, ms)
          viewRef?.current?.scrollIntoView({ behavior: 'auto', block: "center", inline: "center" });
        }

      } else {
        viewRef?.current?.scrollIntoView({ behavior: 'auto', block: "center", inline: "center" });
        ref?.current?.setTransform(0, 0, 1, 0)
        setTimeout(() => {
          ref?.current?.setTransform(0, 0, 1, 0)
          viewRef?.current?.scrollIntoView({ behavior: 'auto', block: "center", inline: "center" });
        }, 200)
        // ref?.current?.centerView(1, 0)
      }
      return
    }
  }, [])

  const activeStatus = {
    undo: false,
    redo: false
  }
  // eslint-disable-next-line
  const { actionStack, actionPointer } = currentState.formJson;

  if (currentState.formJson.actionStack) {
    if (actionStack.length === 0) {
      activeStatus.undo = false
      activeStatus.redo = false
    } else if (actionPointer < actionStack.length && actionPointer > 0) {
      activeStatus.undo = true
      activeStatus.redo = true
    } else if (actionPointer === 0 && actionStack.length !== 0) {
      activeStatus.undo = false
      activeStatus.redo = true
    } else if (actionPointer === actionStack.length) {
      activeStatus.undo = true
      activeStatus.redo = false
    }
  }

  const onClickCommit = () => {

    Http.get(`/apps/${appId}/forms/${formId}?versionId=${versionId}&branchId=${branchId}`).subscribe((res: any) => {
      if (res.length > 0) {
        const data = res[0]
        setResourceLock(data.resourceLock || {})
        if (data.resourceLock.userId === loggedInUserId) {
          setCommitModalVisible(true)
        } else if (!data.resourceLock.userId) {
          WarningToast('No one has checked out this resource. Commit Failed!')
          initializeJson(data)
        } else {
          WarningToast(`${data.resourceLock.userName} has already checked out this resource. Commit Failed!`)
          initializeJson(data)
        }
        // To clear action stack for undo-redo 
        dispatch({
          type: INITIALIZE_ACTION_STACK,
          data: {
            actionStack: [],
            actionPointer: 0
          }
        })
      }
    })

  }

  const onClickCheckout = () => {
    Http.get(`/apps/${appId}/forms/${formId}?versionId=${versionId}&branchId=${branchId}`).subscribe((res: any) => {
      if (res.length > 0) {
        const data = res[0]
        setResourceLock(data.resourceLock || {})
        if (data.resourceLock.userId === loggedInUserId) {
          WarningToast('You have already checked out')
          initializeJson(data)
        } else {
          setCheckoutModalVisible(true)
        }
        if (guideVisible) {
          dispatch(setStepIndex(onboardingInfo.stepIndex + 1));
        }
      }
    })
  }

  const checkout = (resource: any) => {
    const { resourceId, type, resourceType } = resource
    Http.post(`${resourceType}/${resourceId}/checkout`, {
      appId,
      versionId: versionId
    }).subscribe(() => {
      SuccessToast(`${type} checked out`)
      fetchForm()
      if (guideVisible) {
        const stepIndex = onboardingInfo.stepIndex;
        dispatch(setStepIndex(stepIndex + 1));
        const payload = {
          ...onboardingInfo,
          stepIndex: stepIndex + 1
        }
        updateOnboarding(userName, payload)
      }
      setTempModalVisible(false)
      setCheckoutModalVisible(false)
      setLeftPropsNavCollapse(true);
      setRightPropsNavCollapse(true);
      setNavCollapse()

    }, (err) => {
      ErrorToast(`Error checking out ${type}: ${err.message || ''}`)
    })
  }

  const forceRelease = (resource: any) => {
    const { resourceId, type, resourceType } = resource
    Http.post(`${resourceType}/${resourceId}/force-release`, {
      appId,
      versionId: versionId,
      branchId
    }).subscribe(() => {
      SuccessToast(`${type} force released successfully`)
      fetchForm()
      setCheckoutModalVisible(false)
      setLeftPropsNavCollapse(true);
      setRightPropsNavCollapse(true);
      setNavCollapse()
    }, (err) => {
      ErrorToast(`Error force releasing ${type}: ${err.message || ''}`)
    })
  }

  const saveForm = (isCommit?: boolean, discard?: boolean) => {
    Http.get(`/apps/${appId}/forms/${formId}?versionId=${versionId}&branchId=${branchId}`).subscribe((res: any) => {
      if (res.length > 0) {
        const data = res[0]
        setResourceLock(data.resourceLock || {})
        if (data.resourceLock.userId === loggedInUserId) {
          const formData = JSON.parse(JSON.stringify(json))
          addAssetInstancesToForm(formData)
          formData.version = 'v2'
          // the following fields should not be included in the form source
          // as they are only needed in form designer to maintain state
          delete formData.isGridSelected
          delete formData.isAssetInstanceSelected
          delete formData.selectedElementId
          delete formData.modal
          delete formData.snackbar
          delete formData.assetEditMode
          delete formData.actionStack
          delete formData.actionPointer
          delete formData.selectedElementsId

          const data = {
            source: encodeBase64(JSON.stringify(formData)),
            appId: appId,
            version: versionId,
            branchId: branchId,
            styleUrl: json?.styleUrl?.customCssUrl ? json?.styleUrl?.customCssUrl : "",
          }
          Http.put(`/forms/${formId}?isCommit=${isCommit}${discard ? '&discard=true':''}`, data).subscribe((formRes: any) => {
            setFormData(formRes);
            SuccessToast(`Form ${isCommit ? "committed " : "saved"} successfully`)
            isCommit && setResourceLock({
              userId: null
            })
            if (guideVisible) {
              const stepIndex = onboardingInfo.stepIndex;
              let formIds = onboardingInfo.formId || [];
              const formIndex = formIds.findIndex((id: string) => id === formId);
              let formIdx = onboardingInfo.formIndex ? onboardingInfo.formIndex : 0;
              if (formIndex !== -1) {
                formIds.splice(formIndex, 1)
              }
              dispatch(setStepIndex(stepIndex + 1))
              const payload = {
                ...onboardingInfo,
                formId: formIds,
                formIndex: formIdx + 1,
                stepIndex: stepIndex + 1
              }
              updateOnboarding(userName, payload)
              history.goBack();
            }
            if (isCommit) {
              setLeftPropsNavCollapse(false);
              setRightPropsNavCollapse(false);
              setNavCollapse()
            }
            if (discard) {
              const formData: APIFormData = (formRes.source) ? JSON.parse(decodeBase64(formRes.source)) : [];
              if (formData.components) {
                deleteChildAssets(formData.components)
                Object.values(formData.components).forEach((value: any) => {
                  const deviceStyles = value?.properties?.styles[deviceType]
                  if (deviceStyles.hasOwnProperty("fixed")) {
                    if (deviceStyles.fixed) {
                      updatedFixedArray.push(value.id)
                    } else {
                      updatedFixedArray = updatedFixedArray.filter(elem => elem !== value.id);
                    }
                  }
                })
                dispatch(setFixedElements(updatedFixedArray))
              }
              dispatch(initializeV2Json({...formData, selectedElementId}))
            }
          }, (err) => {
            ErrorToast((err && err.message) ? err.message : `Form save failed`)
          })
        } else if (!data.resourceLock.userId) {
          WarningToast('No one has checked out this resource. Save Failed!')
          fetchForm()
        } else {
          WarningToast(`${data.resourceLock.userName} has already checked out this resource. Save Failed!`)
          fetchForm()
        }
      }
    })
  }

  const fetchAssets = useCallback(async () => {
    try {
      if (!orgPermissions?.includes("app.View") || !orgPermissions?.includes("forms.View") &&  loggedInUserId!=selectedOrg?.owner) {
        ErrorToast('Not Authorized: Error fetching assets')
        return
      }
      const res: any = await Http.get(`/orgs/${orgId}/assets`).toPromise();
      const assets: IAssets = {};
      res.data.forEach((item: any) => {
        const json = JSON.parse(decodeBase64(item.source));
        // only get assets built using the solo builder
        if (json.type === "a8solo") {
          const { asset_id, label, id } = item;
          assets[asset_id] = {
            id,
            assetId: asset_id,
            label,
            json,
          };
        }
      });
      return assets
    } catch (err) {
      if (err === "Forbidden") {
        ErrorToast('Not Authorized: Error fetching assets')
      }
      throw new Error(err as any)
    }
  }, [orgId]);

  let updatedFixedArray = [...fixedArr]
  const initializeJson = useCallback(async (data: any) => {
    const formData: APIFormData = (data.source) ? JSON.parse(decodeBase64(data.source)) : [];
    if (formData.components) {
      // child assets are required for rendering asset's children elements on the canvas
      // deleteChildAssets(formData.components)
      Object.values(formData.components).forEach((value: any) => {
        const deviceStyles = value?.properties?.styles[deviceType]
        if (deviceStyles.hasOwnProperty("fixed")) {
          if (deviceStyles.fixed) {
            updatedFixedArray.push(value.id)
          } else {
            updatedFixedArray = updatedFixedArray.filter(elem => elem !== value.id);
          }
        }
      })
      dispatch(setFixedElements(updatedFixedArray))
    }
    dispatch(initializeV2Json(formData))

    try {
      const assets = await fetchAssets();
      dispatch(setAssets(assets));
    } catch (err) {
      logger.debug("failed to fetch assets: ", err);
      dispatch(setAssets({}))
    }

    setLoading(false)
  }, [dispatch, fetchAssets])

  const fetchForm = useCallback(() => {
    Http.get(`/apps/${appId}/forms/${formId}?versionId=${versionId}&branchId=${branchId}`).subscribe((res: any) => {
      try {
        const data = res[0]
        setFormVersion(res[0].isV2)
        setResourceLock(data.resourceLock || {})
        setFormName(data.formName || "")
        setFormData(data);
        initializeJson(data);
        const styles = {
          customCssUrl: data.styleUrl,
          globalCssUrl: selectedApp?.globalcss
        };
        if (data && data.coreVersion === 'v3') {
          dispatch(isCoreV3Form(true))
        } else {
          dispatch(isCoreV3Form(false))
        }
        dispatch(addStyleUrl(styles));
      } catch (e) {
        ErrorToast('Invalid Form')
      }
    }, (error) => {
      ErrorToast('Failed to fetch form')
    })
  }, [formId, versionId, branchId, ErrorToast, appId, initializeJson])

  useEffect(() => {
    loadPlugins(formCoreVersion === 'v3' ? MARKETPLACE_CORE_V3 : MARKETPLACE_CORE_V2, "marketplaceCore", () => {
      initializeA8FormsTypeDefs();
      attachCoreTypeDefs(true);
      fetchForm()
    });
  }, [fetchForm, formCoreVersion]);

  // Load custom and global css;
  const loadCSS = (url: string) => {
    const stylesheet = document.createElement("link");
    stylesheet.setAttribute("rel", "stylesheet");
    stylesheet.setAttribute("type", "text/css");
    stylesheet.setAttribute("href", url);
    document.head.appendChild(stylesheet);
    // stylesheet.onload = (e: any) => { setLoading(false) }
    return true;
  };

  // Attach Global stylesheet when application starts
  const additionalStyleSheetUrl = "https://storage.googleapis.com/public-a8-bucket/GlobalStyles/global.css?ignoreCache=1";
  useEffect(() => {
    // Load the global stylesheet if it's not already loaded
    if (formData?.coreVersion === 'v3') {
      const existingGlobalStylesheet = document.querySelector(`link[href="${additionalStyleSheetUrl}"]`);
      if (!existingGlobalStylesheet) {
        loadCSS(additionalStyleSheetUrl);
      }

      if (formData && formData.styleUrl) {
        loadCSS(formData.styleUrl);
      }
      return () => {
        if (formData && formData.styleUrl) {
          const existingStylesheet = document.querySelector(`link[href="${formData.styleUrl}"]`);
          if (existingStylesheet) {
            existingStylesheet.remove();
          }
        }
      };
    }
  }, [formData, isCoreV3]);

  // once the form builder is rendered, remove `fromSolo:{formId}`
  // keys from localStorage
  useEffect(() => {
    localStorage.removeItem(`fromSolo:${formId}`)
    localStorage.removeItem(`fromAssisted:${formId}`)
  }, [formId]);

  useEffect(() => {
    const wrapper = document.getElementById("mainGrid")
    if (wrapper) {
      wrapper.style.border = !selectedElementId ? "2px solid #fe4365" : "none"
    }

  }, [selectedElementId])

  const handleUndo = useCallback(async () => {
    if (actionStack && activeStatus.undo) {
      actionStack[actionPointer - 1].undo();
      const updatedFixedArray = [...fixedArr];
      updatedFixedArray.pop();
      if (isCoreV3) dispatch(setFixedElementsV3(updatedFixedArray));
      else dispatch(setFixedElements(updatedFixedArray));
    }

    const poppedElement = myUndoStack.getStack();
    const lastElement = poppedElement[poppedElement.length - 1];
    const lastElementId = lastElement ? lastElement.id : "";
    const poppedElementId = lastElementId;

    // highlight the poppedElement or Canvas
    dispatch(setSelectedFormItemId({
      id: poppedElementId,
      isAssetInstanceSelected: false,
      shouldSelectGrid: poppedElementId === "" ? true : false
    }));
  }, [actionStack, actionPointer, activeStatus.undo])



  const handleRedo = useCallback(async () => {
    if (actionStack && activeStatus.redo) {
      const updatedFixedArray = [...fixedArr];
      updatedFixedArray.push(selectedElementId);
      if (isCoreV3) dispatch(setFixedElementsV3(updatedFixedArray));
      else dispatch(setFixedElements(updatedFixedArray));
      await actionStack[actionPointer].redo();
    }
    const poppedElement = myUndoStack.getStack();
    const lastElement = poppedElement[poppedElement.length - 1];
    const lastElementId = lastElement ? lastElement.id : "";
    const poppedElementId = lastElementId;
    dispatch(setSelectedFormItemId({ id: poppedElementId, isAssetInstanceSelected: false, shouldSelectGrid: poppedElementId === "" ? true : false }));
  }, [actionStack, actionPointer, activeStatus.redo])

  const handleCopy = useCallback(async (selectedElementId: string) => {
    const selectedText = document.getSelection();
    const isCopiedText = !!selectedText?.toString()
    if (isCopiedText && selectedText) {
      await navigator.clipboard.writeText(selectedText?.toString());
      return;
    };
    const { components } = getComponents();
    const rootComponent = { ...components[selectedElementId] }
    const copiedComponents: any = {
      [selectedElementId]: rootComponent
    }

    const componentIds = getChildren(rootComponent.fields, components)
    componentIds.forEach(id => {
      copiedComponents[id] = { ...components[id] }
    })

    const data = {
      componentOrder: [selectedElementId],
      components: copiedComponents,
    }

    try {
      await navigator.clipboard.writeText(JSON.stringify(data));
      SuccessToast("Copied to clipboard");
    } catch (err) {
      console.error("failed to copy text: ", err);
    }
  }, [selectedElementId]);

  const modifyIds = (components: any, randomString: string) => {
    for (let key in components) {
      const component = { ...components[key] };
      delete components[key];
      const id = key + randomString;

      if (component.parentId) {
        component.parentId = component.parentId + randomString;
      }

      if (component.id) {
        component.id = component.id + randomString;
      }

      if (Array.isArray(component.fields)) {
        component.fields = component.fields.map((item: any) => item + randomString);
      }

      components[id] = {
        ...component,
      };
    }
    return components
  };

  const validateFormJson = (data: any): boolean => {
    if (Object.keys(data).length === 0) {
      return false
    }
    return true;
  }

  const handlePaste = async (data: any) => {
    try {
      const isValid: boolean = validateFormJson(data);
      if (!isValid) {
        ErrorToast("Invalid form json");
        return;
      }
      const randomString = getRandomId();
      let rootId = data.componentOrder[0] + randomString;
      const modifiedData = modifyIds(data.components, randomString);
      const selectedComp = components[selectedElementId];

      if (containers.includes(selectedComp?.type)) {
        modifiedData[rootId].parentId = selectedElementId
      } else if (!selectedComp) {
        delete modifiedData[rootId].parentId
      } else {
        modifiedData[rootId].parentId = selectedComp.parentId
      }

      const payload: any = {
        rootId,
        components: modifiedData,
        componentOrder: data.componentOrder,
      }

      myUndoStack.push(payload);
      myRedoStack.clear();

      dispatch(pushFormActionStack({
        undo: () => {
          const poppedElement = myUndoStack.pop();
          if (poppedElement) {
            myRedoStack.push(poppedElement);
            dispatch(
              removeElement({
                id: poppedElement.rootId,
                parentId: poppedElement.components[rootId]?.parentId,
                type: poppedElement.components[rootId]?.type,
                increment: -1
              }),
            )
          }
        },
        redo: () => {
          const poppedElement = myRedoStack.pop();
          if (poppedElement) {
            myUndoStack.push({ ...poppedElement });
            dispatch(pasteCopiedElemenet({
              rootId: poppedElement.rootId,
              componentOrder: poppedElement.componentOrder,
              components: poppedElement.components,
              increment: 1
            }));
          }
        }
      }));

      dispatch(pasteCopiedElemenet(payload))
      SuccessToast("Pasted component");
    } catch (err) {
      if (!guideVisible) {
        ErrorToast("Invalid json");
      }
      logger.error(err);
    }
  };

  const handleDelete = useCallback(async () => {
    if (selectedElementId) {
      const component = components[selectedElementId];
      if (component && Object.keys(component)) {
        const childrenArray: FormCreationData[] = [];
        getNestedComponents(components, component?.fields, childrenArray);

        const payload: FormCreationData = {
          ...component,
          id: components[selectedElementId].id,
          parentId: components[selectedElementId].parentId || "",
          type: components[selectedElementId].type,
          children: childrenArray,
        }
        // remove the child reference from parent node
        if (components[selectedElementId].parentId) {
          const parentId: any = components[selectedElementId].parentId;
          payload.metadata = {
            position: components[parentId].fields.indexOf(components[selectedElementId].id)
          }
        }
        // Undo Redo for delete elements
        myUndoStack.push({ ...payload });
        // component order
        myUndoStack.saveOrder(componentOrder);
        const order = myUndoStack.getOrder();

        dispatch(pushFormActionStack({
          undo: () => {
            const poppedElement = myUndoStack.pop();
            if (poppedElement) {
              myRedoStack.push(poppedElement);
              dispatch(
                undoDeleteElement(poppedElement, order),
              )
            }
          },
          redo: () => {
            const poppedElement = myRedoStack.pop();
            if (poppedElement) {
              myUndoStack.push({ ...poppedElement });
              dispatch(removeElement({
                id: poppedElement.id,
                parentId: poppedElement.parentId || "",
                type: poppedElement.type,
                increment: 1
              }))
            }
          }
        }));

        dispatch(removeElement({
          id: components[selectedElementId].id,
          parentId: components[selectedElementId].parentId,
          type: components[selectedElementId].type
        }))
      }
    }
  }, [selectedElementId])

  let handleDuplicateSetState = () => {
    setduplicateState({ visible: true });
    setMoreOptionsVisible(false);
  }

  const selection: any = window.getSelection();
  const handleKeyDown = async (event: KeyboardEvent) => {
    const os = getOs();

    let helperKey = os === OS.Mac ? event.metaKey : event.ctrlKey

    let mainCanvas: any = document.getElementById("mainCanvas");
    if (!mainCanvas) return;
    const isInsideMainCanvas = mainCanvas.contains(event.target);
    const isInputField = (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) && !isInsideMainCanvas;

    
    // Check if the focused element is editable content
    const isEditableContent = (event.target instanceof HTMLElement && event.target.isContentEditable);
    const dateRangePickerEditableFromInput = event.target instanceof HTMLElement && component?.type === "DateRangePicker" && event.target.getAttribute("placeholder") === "DD/MM/YYYY";
    const dateRangePickerEditableEndInput = event.target instanceof HTMLElement && component?.type === "DateRangePicker" && event.target.getAttribute("placeholder") === "DD/MM/YYYY";
    const doubleClicked = sessionStorage.getItem('doubleClicked') === 'true';
    
    if (helperKey && event.key === "z" && isCheckedIn && !assetEditMode.isEnabled && !isInputField) {
      event.preventDefault();
      handleUndo()
    }
    else if (helperKey && event.key === "y" && isCheckedIn && !assetEditMode.isEnabled && !isInputField) {
      event.preventDefault()
      handleRedo()
    } else if (helperKey && event.key === "c" && isCheckedIn && !assetEditMode.isEnabled && selection.toString().length === 0 && !isInputField) {
      event.preventDefault()
      handleCopy(selectedElementId)
    }
    else if (helperKey && event.key === "v" && isCheckedIn && !assetEditMode.isEnabled && !isInputField) {
      const clipboardData = await navigator.clipboard.readText();
      try {
        const data = JSON.parse(clipboardData)
        event.preventDefault()
        handlePaste(data)
      } catch (error) {
        if (!clipboardData) {
          ErrorToast("Invalid JSON")
          return;
        }
      }
    } if (event.key === "Delete" && isCheckedIn && !assetEditMode.isEnabled && !isInputField) {
      if (!isEditableContent && !doubleClicked && !dateRangePickerEditableFromInput && !dateRangePickerEditableEndInput) {
        event.preventDefault();
        handleDelete();
      }
    } else if (helperKey && event.key === "V" && event.shiftKey && isCheckedIn && !assetEditMode.isEnabled) {
      event.preventDefault();
      handlePasteStyles();
    } else if (helperKey && event.key === "k" && isCheckedIn && !assetEditMode.isEnabled) {
      event.preventDefault();
      setTempModalVisible(true)
    } else if (event.key === "Escape" && isCheckedIn && !assetEditMode.isEnabled) {
      event.preventDefault();
      setTempModalVisible(false)
    }
  }
  const getTargetDeviceTypes = (currentDeviceType: 'Sm' | 'Md' | 'Lg'): string[] => {
    if (currentDeviceType === "Sm") {
      return ['Md', 'Lg'];
    } else if (currentDeviceType === "Md") {
      return ['Sm', 'Lg'];
    } else if (currentDeviceType === "Lg") {
      return ['Sm', 'Md'];
    } else {
      return [];
    }
  }

  const handlePasteStyles = async () => {
    try {
      const clipboardData = await navigator.clipboard.readText();
      const data = JSON.parse(clipboardData);
      const isValid = validateFormJson(data);

      if (!isValid) {
        ErrorToast("Invalid form json");
        return;
      }

      const selectedComp = JSON.parse(JSON.stringify(components[selectedElementId]));
      const copiedComp = data.components[data.componentOrder[0]];
      const modifiedData = JSON.parse(JSON.stringify(components));

      if (copiedComp.type === selectedComp.type) {
        modifiedData[selectedElementId] = { ...selectedComp };
      } else {
        ErrorToast("Widget mismatched");
        return;
      }

      const styles = await copiedComp?.properties?.styles;
      modifiedData[selectedElementId].properties.styles = styles;

      const currentState: any = {
        rootId: selectedElementId,
        components: JSON.parse(JSON.stringify(components)),
        componentOrder: [...data.componentOrder]
      };

      const newState: any = {
        rootId: selectedElementId,
        components: modifiedData,
        componentOrder: data.componentOrder
      };

      myUndoStack.push(currentState);
      myRedoStack.clear();

      dispatch(pushFormActionStack({
        undo: () => {
          const poppedElement = myUndoStack.pop();
          if (poppedElement) {
            myRedoStack.push(newState);
            dispatch(applyStyles({
              rootId: poppedElement.rootId,
              componentOrder: poppedElement.componentOrder,
              components: poppedElement.components,
              increment: -1,
            }));
          }
        },
        redo: () => {
          const poppedElement = myRedoStack.pop();
          if (poppedElement) {
            myUndoStack.push(currentState);
            dispatch(applyStyles({
              rootId: poppedElement.rootId,
              componentOrder: poppedElement.componentOrder,
              components: poppedElement.components,
              increment: 1,
            }));
          }
        }
      }));

      SuccessToast("Pasted");
      dispatch(applyStyles(newState));
    } catch (err) {
      ErrorToast("Invalid json");
      logger.error(err);
    }
  };

  const handleSyncStyle = (targetDeviceType: string) => {
    const fixed = component?.properties?.styles[deviceType]?.fixed
    if (fixed) {
      const targetDeviceTypes = getTargetDeviceTypes(deviceType);
      if (targetDeviceTypes.some((targetDeviceType) => fixedArrayV3[targetDeviceType].length > 0)) {
        ErrorToast("Target device types already have fixed elements. Cannot sync styles.");
        return;
      }
    }
    const componentIdsToUpdate = Object.keys(components);
    syncStyles({
      componentIdsToUpdate: componentIdsToUpdate,
      deviceType: deviceType,
      changeTo: targetDeviceType,
      syncTo: "ALL",
    })

    if (fixedArrayV3[deviceType].length === 0) {
      fixedArrayV3[targetDeviceType] = [];
    }

    let updatedFixedArray = { ...fixedArrayV3 };
    const targetDeviceTypes = getTargetDeviceTypes(deviceType);
    targetDeviceTypes.forEach((targetDeviceType: string) => {
      const idsToUpdate = fixed ? [selectedElementId, ...fixedArrayV3[targetDeviceType]] : fixedArrayV3[targetDeviceType].filter((id: any) => id !== selectedElementId);
      updatedFixedArray[targetDeviceType] = idsToUpdate;
    });
    dispatch(setFixedElementsUpdateV3(updatedFixedArray));
  };

  useEffect(() => {
    const newFormBuilder = document.getElementById("newFormBuilder");
    document.removeEventListener('keydown', handleKeyDown)
    if (newFormBuilder && newFormBuilder.getAttribute("keydownListener") !== "true") {
      document.addEventListener("keydown", handleKeyDown);
      if (newFormBuilder) {
        newFormBuilder.setAttribute("keydownListener", "true");
      }
    }
    return () => {
      if (newFormBuilder) {
        document.removeEventListener('keydown', handleKeyDown)
        newFormBuilder.setAttribute("keydownListener", "false");
      }
    };
  }, [selectedElementId, actionStack, actionPointer])

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '75vh', width: "100%" }}>
      <Spin indicator={<Icon type="loading" style={{ fontSize: 24, color: '#15808C' }} spin />} />
    </div>
  }

  const renderDropDown = (selectedDeviceType: 'Lg' | 'Sm' | 'Md', options: Device[]) => {
    return (selectedDeviceType === deviceType && showDeviceList) ? (
      <Popover.Panel static className="absolute z-20 w-208">
        <div className="rounded mt-2 ml-1 border bg-white templete_border"
          style={{ boxShadow: "0px 5px 8px 0px rgba(125, 132, 146, 0.11)", paddingTop: "10px", maxHeight: "275px" }}>
          {
            options.map((item: Device) => {
              return (
                <div
                  key={item.name}
                  style={{
                    color: (device.name === item.name) ? '#F1722E' : '#505F7B', background: (device.name === item.name) ? '#eaf5ff' : undefined,
                    fontSize: "11px", padding: "0px 0px 10px 10px"
                  }}
                  onClick={() => {
                    dispatch(selectedDevice(item))
                    setShowDeviceList(false)
                    setSavedDevices({
                      ...savedDevices,
                      [deviceType]: item
                    })
                  }}
                  className=" font-semibold cursor-pointer bg-white hover:bg-gray-100 w-208"
                >
                  {item.name}
                  <span style={{ color: (device.name === item.name) ? '#F1722E' : '#505F7B' }} className="text-md text-gray-400"> ({item.resolution})</span>
                </div>
              )
            })
          }
        </div>
      </Popover.Panel>
    ) : null
  }

  const renderZoomDropDown = () => {
    const options = [{
      label: 'Zoom in',
      text: 'Ctrl +',
      onClick: () => {
        setTransform(zoomRef, 'in')
      }
    }, {
      label: 'Zoom out',
      text: 'Ctrl -',
      onClick: () => {
        setTransform(zoomRef, 'out')
      }
    }, {
      label: 'Auto',
      value: 'Auto',
      text: '',
      onClick: () => {
        setTransform(zoomRef, 'fit')
      }
    }, {
      label: 'Zoom to 50%',
      value: '50%',
      text: '',
      onClick: () => {
        setTransform(zoomRef, '50')
      }
    }, {
      label: 'Zoom to 100%',
      value: '100%',
      text: '',
      onClick: () => {
        setTransform(zoomRef, '100')
      }
    }, {
      label: 'Zoom to 200%',
      value: '200%',
      text: '',
      onClick: () => {
        setTransform(zoomRef, '200')
      }
    }]
    return showZoomPopup ? (
      <Popover.Panel static className="absolute z-20 w-52">
        <div className="shadow-lg mt-3" style={{ border: '2px solid #A8ABBB66', borderRadius: '4px' }}>
          {
            options.map((item) => {
              return (
                <div onClick={() => {
                  setShowZoomPopup(false)
                  if (item.value) {
                    setZoomScale(item.value)
                  }
                  item.onClick()
                }} className="p-3 flex justify-between items-center hover:bg-gray-100 bg-gray-50 cursor-pointer">
                  <span style={{ color: '#292D32', fontSize: '14px' }}>{item.label}</span>
                  <span style={{ color: '#8D8D8D', fontSize: '11px' }}>{item.text}</span>
                </div>
              )
            })
          }
        </div>
      </Popover.Panel>
    ) : null
  }

  const morePopovercontent = (
    <div>
      {<div onClick={() => {
        setViewFormProperties(true)
        setMoreOptionsVisible(false)
      }} style={{ display: 'flex', gap: '8px', cursor: "pointer" }}>
        <img data-test-id="form_properties" src={settingIcons} alt="morIcon" />
        <div>Form Properties</div>
      </div>}
      <div onClick={() => {
        handleDuplicateSetState()
      }} style={{ display: 'flex', gap: '8px', cursor: "pointer", marginTop: "10px", marginLeft: "1px" }}>
        <img data-test-id="form_duplicate" src={duplicate} alt="morIcon" />
        <div>Duplicate</div>
      </div>
    </div>
  );

  const handleCanvasWrapperClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    dispatch(setSelectedFormItemId({ id: "", isAssetInstanceSelected: false, shouldSelectGrid: true }));
    dispatch(setModalVisibility({
      visible: false,
      componentId: "",
    }))
  }
  const dropdownStyle: React.CSSProperties = {
    background: '#95ABD34B',
    padding: '4px',
    borderRadius: '3px',
  };
  const soloAssitedCheck = (fromSolo && !fromAssisted) ? false : (!fromSolo && fromAssisted) ? false : true

  return (
    <>
      <div id="newFormBuilder" className="grid h-screen core-v2 overflow-hidden" tabIndex={9999} onKeyDown={(e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === '-') {
          e.preventDefault()
          setTransform(zoomRef, 'out')
          return
        }
        if ((e.ctrlKey || e.metaKey) && e.key === '=') {
          e.preventDefault()
          setTransform(zoomRef, 'in')
          return
        }
      }} onClick={() => { setShowDeviceList(false); setShowZoomPopup(false) }} style={{ gridTemplateRows: '50px 1fr', width: 'calc(100vw - 60px)' }} >
        <div style={{ height: '50px' }} className="flex items-center justify-between">
          <div className="flex justify-between">
            <div className="flex items-center justify-items-center">
              <span
                className={`${(fromSolo && !fromAssisted) ? "cursor-not-allowed" : (!fromSolo && fromAssisted) ? "cursor-not-allowed" : "cursor-pointer"}`}
                onClick={() => {
                  const data = formData?.source ? JSON.parse(decodeBase64(formData?.source)) : {}; 
                  const checkValues = !isCheckedIn ? sourceKeysCheckedout : sourceKeys
                  const changesFound = checkValues.some(k => {
                    return JSON.stringify(json[k]) !== JSON.stringify(data[k]);
                  });
                  if (changesFound) {
                    setFormSaveModalVisibility(true);
                  } else {
                    if (soloAssitedCheck) {
                      dispatch(clearFormV2Json());
                      history.push(`/apps/list/${appId}/${appType}/forms/list`);
                    }
                  }
                }}
              >
                <Left className="m-3" style={{ fill: (fromSolo && !fromAssisted) ? "#8a8989" : (!fromSolo && fromAssisted) ? "#8a8989" : "#0466C8" }} />
              </span>
              <span className="text-xl font-semibold" style={{ color: '#0466C8' }}>
                {formName}
              </span>
            </div>
            <div style={{ borderLeft: '1px solid #95ABD333', height: "40px", marginLeft: "17px", marginRight: "17px" }}></div>
            <div className="flex items-center justify-between">
              <Popover className="relative mr-3" style={deviceType === 'Lg' ? dropdownStyle : {}}>
                <Popover.Button onClick={() => {
                  if (deviceType === 'Lg') {
                    if (showDeviceList) {
                      setShowDeviceList(false)
                    } else {
                      setShowDeviceList(true)
                    }
                  } else {
                    dispatch(selectedDeviceType('Lg'))
                    dispatch(selectedDevice(savedDevices['Lg']))
                    setShowDeviceList(false)
                  }
                }} className="flex justify-center items-center focus:outline-none" title="Desktop">
                  <Desktop style={{ color: deviceType === 'Lg' ? '#0466C8' : '#969BA5', margin: '4px' }} className="cursor-pointer" />
                  <CaretDownIcon style={{ color: deviceType === 'Lg' ? '#0466C8' : '#969BA5', height: '6px', width: '7px' }} />
                </Popover.Button>
                {
                  renderDropDown('Lg', LargeDevices)
                }
              </Popover>
              <Popover className="relative mr-3" style={deviceType === 'Md' ? dropdownStyle : {}}>
                <Popover.Button onClick={() => {
                  if (deviceType === 'Md') {
                    if (showDeviceList) {
                      setShowDeviceList(false)
                    } else {
                      setShowDeviceList(true)
                    }
                  } else {
                    dispatch(selectedDeviceType('Md'))
                    dispatch(selectedDevice(savedDevices['Md']))
                    setShowDeviceList(false)
                  }
                }} className="flex justify-center items-center focus:outline-none" title="Tablet">
                  <Tablet style={{ color: deviceType === 'Md' ? '#0466C8' : '#969BA5', margin: '4px' }} className="cursor-pointer" />
                  <CaretDownIcon style={{ color: deviceType === 'Md' ? '#0466C8' : '#969BA5', height: '6px', width: '7px' }} />
                </Popover.Button>
                {
                  renderDropDown('Md', TabletDevices)
                }
              </Popover>
              <Popover className="relative mr-3" style={deviceType === 'Sm' ? dropdownStyle : {}}>
                <Popover.Button onClick={() => {
                  if (deviceType === 'Sm') {
                    if (showDeviceList) {
                      setShowDeviceList(false)
                    } else {
                      setShowDeviceList(true)
                    }
                  } else {
                    dispatch(selectedDeviceType('Sm'))
                    dispatch(selectedDevice(savedDevices['Sm']))
                    setShowDeviceList(false)
                  }
                }} className="flex justify-center items-center focus:outline-none" title="Mobile">
                  <Mobile style={{ color: deviceType === 'Sm' ? '#0466C8' : '#969BA5', margin: '4px' }} className="cursor-pointer" />
                  <CaretDownIcon style={{ color: deviceType === 'Sm' ? '#0466C8' : '#969BA5', height: '6px', width: '7px' }} />
                </Popover.Button>
                {
                  renderDropDown('Sm', MobileDevices)}
              </Popover>
            </div>
            {isCheckedIn && !assetEditMode.isEnabled && (
              <div className="flex justify-center items-center" style={{ borderLeftWidth: '1px', height: '40px', paddingLeft: '10px' }}>
                <UndoSvg
                  className="cursor-pointer"
                  data-test-id="undo"
                  height='20px'
                  width='20px'
                  stroke={activeStatus.undo ? '#292D32' : '#d3d3d3'}
                  onClick={handleUndo}
                />
                <RedoSvg
                  className="cursor-pointer"
                  style={{ marginLeft: "10px" }}
                  data-test-id="redo"
                  height='20px'
                  width='20px'
                  stroke={activeStatus.redo ? '#292D32' : '#d3d3d3'}
                  onClick={handleRedo}
                />
              </div>
            )}
          </div>
          <div className="flex gap-4 mr-4 items-center">
            {(isCheckedIn && (formData?.coreVersion?.toLowerCase?.() === 'v3')) && <div className={style.templateHead} onClick={() => { setTempModalVisible(true) }}><span style={{ paddingRight: "6px" }}><TemplateIcon /></span>Template</div>}
            {isCheckedIn && <div className="flex items-center gap-4  pr-3" style={{ borderRight: "1px solid rgba(149, 171, 211, 0.2)", height: "40px" }}>
              <div className="cursor-pointer" title="Toggle Secondary Sidebar" onClick={() => { setLeftPropsNavCollapse(!leftPropsNavCollapse); setNavCollapse() }}>
                <NavCollapse className={'cursor-pointer'} active={leftPropsNavCollapse} />
              </div>
              <div title="Toggle Primary Sidebar" className="cursor-pointer" onClick={() => { setRightPropsNavCollapse(!rightPropsNavCollapse); setNavCollapse() }}>
                <NavCollapse className={'cursor-pointer'} active={rightPropsNavCollapse} style={{ transform: 'rotate(180deg)' }} />
              </div>
            </div>}
            {isCheckedIn && canEdit && currentVersion && !assetEditMode.isEnabled && <AntPopover placement="bottom" content={morePopovercontent}
              visible={moreOptionsVisible}
              trigger="click"
              onVisibleChange={(e) => {
                setMoreOptionsVisible(e)
              }}
            >
              <div data-test-id="more" style={{ cursor: "pointer", color: 'black' }} onClick={() => {
                setMoreOptionsVisible(true)
              }}>
                <MoreIcon height='24px' width='24px' />
              </div>
            </AntPopover>
            }
            <div className="pr-4" style={{ borderColor: '#e5e7eb', borderRightWidth: '1px', height: '40px', display: 'flex', alignItems: 'center', marginRight: '8px' }}>
              <Popover className="relative">
                <Popover.Button onClick={() => showZoomPopup ? setShowZoomPopup(false) : setShowZoomPopup(true)} className="flex justify-center items-center focus:outline-none">
                  <span className="mr-2" style={{ color: '#292D32', fontSize: '13px', fontWeight: 500 }}>{zoomScale}</span>
                  <CaretDownIcon style={{ height: '7px', width: '7px', color: '#292D32' }} />
                </Popover.Button>
                {
                  renderZoomDropDown()
                }
              </Popover>
            </div>
            {
              canEdit && currentVersion && !assetEditMode.isEnabled && (
                <>
                  {isCoreV3 && isCheckedIn && (
                    <SyncStyle
                      syncTo="ALL"
                      deviceType={deviceType}
                      handleSync={handleSyncStyle}
                    />
                  )}
                  {isCheckedIn && <ImportIcon title="Marketplace" style={{ backgroundColor: '#95ABD34B' }} height="30px" width="30px" className="cursor-pointer p-2 rounded-lg" />}
                  {
                    isCheckedIn ?
                      <button style={{ color: '#052f35 ', border: "1px solid #052f35 ", height: "26px" }} className="text-sm font-medium py-0 px-2 rounded-lg  tracking-wide" onClick={onClickCommit}>
                        Commit
                      </button>
                      :
                      <button style={{ color: '#052f35 ', border: "1px solid #052f35 ", height: "26px" }} className="form_checkout text-sm font-medium py-2 px-2 rounded-lg  tracking-wide" onClick={onClickCheckout}>
                        Checkout
                      </button>
                  }
                  {isCheckedIn && <button data-test-id="Save_Button" style={{ color: "white", backgroundColor: '#052f35 ', height: "26px" }} className="text-sm font-medium py-2 px-2 rounded-lg tracking-wide tour_v2_form_save" onClick={() => saveForm(false)}>
                    Save
                  </button>}
                </>
              )
            }
            {canEdit && currentVersion && assetEditMode.isEnabled && <AssetController />}
          </div >
        </div >
        <div className="w-full grid overflow-auto relative" style={{ transition: 'all .4s', width: "100%" }}>
          <div ref={formPropsLeftRef} className={"absolute bg-white z-10"} style={{ height: 'calc(100% - 5px)', borderRight: '1px solid #95ABD333', left: 0, top: 0, transition: 'all .2s', width: leftPropsNavCollapse ? "262px" : '0px' }}>
            {leftPropsNavCollapse && <FormPropsLeftNav isCheckedIn={isCheckedIn} />}
          </div>
          <div style={{ background: "#F5F5F5" }} className="bg-gray-50 border border-gray-100 z-0 overflow-auto h-full" onClick={handleCanvasWrapperClick}>
            <FormDesigner viewRef={viewRef} zoomScale={getComputedZoomPercent} setZoomScale={setZoomScale} isCheckedIn={isCheckedIn} setTransform={setTransform} onZoomStop={onZoomStop} zoomRef={zoomRef} />
          </div>
          <div ref={formPropsRightRef} className="h-full flex flex-col justify-between overflow-auto absolute bg-white panel-settings" style={{height: 'calc(100% - 5px)',borderLeft: '1px solid #95ABD333',width: rightPropsNavCollapse ? "295px" : "0px",right: 0,top: 0, transition: 'all .2s'}}> 
            {rightPropsNavCollapse && <FormProps isCheckedIn={isCheckedIn} />}
          </div>
        </div>
      </div >
      {
        appType === 'assist' ? (
          viewFormProperties &&
          <FormPropertiesModal data={currentState.formJson} dispatch={dispatch} formId={formId} isV2Form={true} viewFormProperties={viewFormProperties} setViewFormProperties={setViewFormProperties} />
        ) : (
          <SoloFormPropertiesModal viewFormProperties={viewFormProperties} setViewFormProperties={setViewFormProperties} />
        )
      }
      <DuplicateFormModal
        data-test-id="duplicate_form_modal"
        visible={duplicateState.visible}
        setvisible={(e: any) => {
          setduplicateState({ visible: e })
        }}
        appType="solo"
      />
      <Modal
        id='checkoutModal'
        dataTestId='checkoutModal'
        title={!resourceLock.userId ? "CHECKOUT" : "WARNING"}
        visible={checkoutModalVisible}
        onCancel={() => {
          setCheckoutModalVisible(false)
        }}
        unmountOnCancel={true}
        footer={{
          enable: false
        }}
      >
        <>
          {
            !resourceLock.userId ?
              <>
                <div className={style.modalMsg}>
                  Do you want to checkout ?
                </div>
                <div className={style.note}>
                  Note: This will prevent others from editing this resource until you commit
                </div>
              </>
              :
              <>
                <div className={style.modalMsg}>
                  <span className={style.modalHighlightedMsg}>{resourceLock.userName}</span> has currently checked out this resource
                </div>
                {
                  (
                    canForceRelease
                  ) &&
                  <>
                    <div className={style.modalMsg}>
                      Do you want to force release ?
                    </div>
                    <div className={style.note}>
                      Note: This will revoke editing access from the currently checked out user.
                    </div>
                  </>
                }
              </>
          }
          <ModalFooter
            okCallback={() => {
              const resource = {
                resourceId: formId,
                type: 'Form',
                resourceType: 'forms'
              }
              if (!resourceLock.userId) {
                checkout(resource)
              } else if (
                (canForceRelease)
              ) {
                forceRelease(resource)
              } else {
                setCheckoutModalVisible(false)
              }
            }}
            cancelCallback={() => {
              setCheckoutModalVisible(false)
            }}
            okText={!resourceLock.userId ? "CHECKOUT" : (
              (canForceRelease)
            ) ? "FORCE RELEASE" : "OK"}
            cancelText={"CANCEL"}
            okClassName="form_checkout_ok"
          />
        </>
      </Modal>
      <Modal
        id='commitModal'
        dataTestId='commitModal'
        title="COMMIT"
        visible={commitModalVisible}
        onCancel={() => {
          setCommitModalVisible(false)
        }}
        unmountOnCancel={true}
        footer={{
          enable: false,
        }}
      >
        {
          <>
            <div className={style.modalMsg}>
              Do you wish to commit ?
            </div>
            <ModalFooter 
              okText="SAVE & COMMIT" 
              cancelText="DISCARD & COMMIT" 
              okCallback={()=>{saveForm(true); setCommitModalVisible(false)}} 
              cancelCallback={()=>{saveForm(true, true); setCommitModalVisible(false)}} 
              cancelClassName="discard_btn"
            />
          </>
        }
      </Modal>
      <TemplateModal
        isCheckedIn={isCheckedIn}
        isVisible={tempModalVisible}
        isV2 = {formData?.coreVersion?.toLowerCase?.() === 'v2'}
        onClose={() => { setTempModalVisible(false) }}
      />
      <Modal
        id="confirmFormPopup"
        dataTestId="confirmFormPopup"
        title={
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <p style={{ marginBottom: 0 }}>SAVE</p>
            <div style={{ cursor: 'pointer' }} onClick={() => { setFormSaveModalVisibility(false) }}>X</div>
          </div>
        }
        closable={false}
        unmountOnCancel={true}
        visible={formSaveModalVisibility}
        onCancel={() => {
          setFormSaveModalVisibility(false);
          if (soloAssitedCheck) {
            dispatch(clearFormV2Json());
            history.push(`/apps/list/${appId}/${appType}/forms/list`);
          }
        }}
        footer={{
          enable: true,
          okText: "SAVE",
          cancelText: "CANCEL",
          onOk: () => {
            setFormSaveModalVisibility(false);
            saveForm(false)
            if (soloAssitedCheck) {
              dispatch(clearFormV2Json())
              history.push(`/apps/list/${appId}/${appType}/forms/list`)
            }
          }
        }}
      > <div className={style.modalMsg}>
          Do you want to save your changes ?
        </div></Modal>
    </>
  );
};

const AssetController = () => {
  const dispatch = useDispatch();
  const { SuccessToast, ErrorToast } = useToast();
  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const assetEditMode = useSelector(
    (state: AppState) => state.formJson.assetEditMode
  );
  const assets = useSelector((state: AppState) => state.formJson.assets);
  const asset = assets[assetEditMode.assetId];

  const handleSave = async () => {
    const payload = {
      assetId: asset.assetId,
      label: asset.label,
      source: encodeBase64(JSON.stringify(asset.json)),
    };

    if (asset.id) {
      try {
        await Http.put(`orgs/${orgId}/assets/${asset.id}`, payload).toPromise()
        SuccessToast("Asset updated");
        dispatch(
          setAssetEditMode({
            isEnabled: false,
            assetId: "",
          })
        );

        const parentComponent = asset?.json?.components?.[asset?.json?.componentOrder?.[0]];
        const data = {
          isAsset: true,
          type: parentComponent?.type
        }
        store.dispatch({
          type: CREATE_FORM_JSON,
          data
        });
        const formJson = store.getState().formJson;
        addAssetInstancesToForm(formJson);
      } catch (err) {
        logger.debug(`failed to update asset ${asset.id}: `, err)
        ErrorToast("Unable to update asset");
      }
    }
  };

  const handleCancel = () => {
    dispatch(discardAssetChanges());
  };

  return (
    <div className="space-x-10 mr-4">
      <button
        onClick={handleCancel}
        style={{
          color: "#292D32",
          fontSize: 17,
          fontFamily: 'inherit',
          fontWeight: 500,
          outline: 'none',
        }}
      >
        Cancel
      </button>
      <button
        style={{
          backgroundColor: "#E27841",
          color: "#FFF",
          padding: '4px 16px',
          borderRadius: 5,
          fontSize: 17,
          fontFamily: 'inherit',
          outline: 'none',
        }}
        onClick={handleSave}
      >
        Save
      </button>
    </div>
  );
};